import React from "react";
import { useQuery, gql } from "@apollo/client";
import { Link } from "gatsby";
import { formatDate, estimateReadTime } from "../../utils";

export const NewsIndexSticky = () => {
  let page = 1;

  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    page = parseInt(params.get("page") || "1");
  }

  const { data, loading } = useQuery(
    gql`
      query NewsQuery {
        posts(first: 1, where: { onlySticky: true }) {
          nodes {
            databaseId
            title
            excerpt
            uri
            date
            content
            tags {
              nodes {
                link
                name
                slug
              }
            }
            featuredImage {
              node {
                sourceUrl(size: LARGE)
              }
            }
          }
          pageInfo {
            offsetPagination {
              total
            }
          }
        }
      }
    `
  );

  // const totalResults = data?.posts?.pageInfo?.offsetPagination?.total || 0;

  // console.log("DATA: ", data, loading, error)
  if (page === 1) {
    return (
      <div className="min-w-fit">
        {!loading && !!data?.posts?.nodes?.length && (
          // Slider
          <div>
            {data.posts.nodes.map((post) => (
              <article
                key={post.databaseId}
                className="flex w-[1100px] justify-between items-center gap-20 p-4"
              >
                <div className="flex w-[40%] flex-col content-evenly justify-items-stretch">
                  <h2 className="text-left text-3xl font-bold leading-tight text-color-black">
                    <Link
                      className="cursor-pointer text-left text-3xl font-bold leading-tight !text-color-black no-underline"
                      to={post.uri}
                    >
                      {post.title}
                    </Link>
                  </h2>
                  <div
                    className="text-color-gray-dark mb-3 text-base"
                    dangerouslySetInnerHTML={{ __html: post.excerpt }}
                  ></div>
                  <div className="reading text-sm text-color-gray-dark mb-3">
                    <span>{formatDate(post.date)}</span>
                    <span>&nbsp;&bull;&nbsp;</span>
                    <span>{estimateReadTime(post.content)} minute read</span>
                  </div>
                  <div className="tags text-color-gray-dark">
                    {post.tags.nodes.map((tag) => (
                      <h4 className="text-xs uppercase pb-1 border-color-gray-dark-2 text-color-black w-auto inline-block ease-in-out duration-300 hover:border-b-0 border-b-4">{tag.name}</h4>
                    ))}
                  </div>
                </div>
                {!!post.featuredImage?.node?.sourceUrl && (
                  <div className="relative h-[500px] w-[500px] rounded-full bg-color-gray-light">
                    <Link to={post.uri}>
                      <img
                        className="absolute top-[50%] right-0 aspect-square h-[450px] translate-y-[-50%] rounded-full object-cover hover:right-[12.5px] ease-in-out duration-500"
                        src={post.featuredImage.node.sourceUrl}
                        alt=""
                      />
                    </Link>
                  </div>
                )}
              </article>
            ))}
          </div>
        )}
      </div>
    );
  }
  return null;
};
